module.exports = __webpack_public_path__ + "static/media/anz.e31abdc8.png";